import axios from 'axios';

export const getAddress = async (address: string) => {
  const { data } = await axios.get('https://dapi.kakao.com/v2/local/search/address', {
    headers: {
      Authorization: `KakaoAK ${import.meta.env.VITE_KAKAO_APP_KEY}`
    },
    params: {
      query: address
    }
  });

  return data;
};
